module.exports = __webpack_public_path__ + "static/img/default-user.f8259fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/default-user.png
// module id = Dbjv
// module chunks = 15